/**
 * @desc Layers to import into the store
 *
 * @author Mike Hamilton <mike@mikehamilton.ca>
 */

import snowmaking from "./snowmaking";
import liftmaintenance from "./liftmaintenance";
import landuse from "./landuse";
import utilities from "./utilities";
import bikepark from "./bikepark";
import hiking from "./hiking";
import electrical from "./electrical";
import patrol from "./patrol";
import signshop from "./signshop";
import designatedroutes from "./designatedroutes";
import grooming from "./grooming";
import wintertrails from "./wintertrails";
import buildingmaintenance from "./buildingmaintenance";
import liftopsdesignatedroutes from "./liftopsdesignatedroutes";
import summerops from "./summerops";
import topolines from "./topolines";

export default {
  modules: {
    // Order as wanted in the menu
    topolines,
    bikepark,
    buildingmaintenance,
    designatedroutes,
    electrical,
    grooming,
    landuse,
    liftmaintenance,
    liftopsdesignatedroutes,
    patrol,
    signshop,
    snowmaking,
    summerops,
    hiking,
    utilities,
    wintertrails
  }
};
